// Dados de exemplo. peso em GRAMAS; dimensões (embalagem) em CM.
export const PRODUTOS_INICIAL = [
    { id: 1, nome: 'Base de Corte A3 - 45x30cm', sku: 'BC-A3-001', custo: 18.50, unidade: 'un', peso: 350 },
    { id: 2, nome: 'Base de Corte A4 - 30x22cm', sku: 'BC-A4-001', custo: 12.00, unidade: 'un', peso: 200 },
    { id: 3, nome: 'Refil Adesivo 8mm x 10m', sku: 'RA-8-10', custo: 2.80, unidade: 'un', peso: 50 },
    { id: 4, nome: 'Refil Adesivo 6mm x 12m', sku: 'RA-6-12', custo: 3.20, unidade: 'un', peso: 50 },
    { id: 5, nome: 'Lâmina Cameo Autoblade', sku: 'LC-AUTO', custo: 45.00, unidade: 'un', peso: 30 },
    { id: 6, nome: 'Kit Ferramentas Silhouette', sku: 'KF-SIL', custo: 28.00, unidade: 'kit', peso: 200 },
];

export const EMBALAGENS_INICIAL = [
    { id: 1, nome: 'Envelope Kraft 20x30', sku: 'EMB-EK-001', custo: 0.45, unidade: 'un', peso: 15, comprimento: 30, largura: 20, altura: 1 },
    { id: 2, nome: 'Caixa Correio N1', sku: 'EMB-CX-N1', custo: 1.20, unidade: 'un', peso: 80, comprimento: 16, largura: 11, altura: 6 },
    { id: 3, nome: 'Caixa Correio N2', sku: 'EMB-CX-N2', custo: 1.80, unidade: 'un', peso: 120, comprimento: 27, largura: 18, altura: 9 },
    { id: 4, nome: 'Caixa Correio N3', sku: 'EMB-CX-N3', custo: 2.50, unidade: 'un', peso: 160, comprimento: 27, largura: 18, altura: 13 },
    { id: 5, nome: 'Plástico Bolha 30cm', sku: 'EMB-PB-30', custo: 0.35, unidade: 'm', peso: 10, comprimento: 30, largura: 20, altura: 1 },
];

export const INSUMOS_INICIAL = [
    { id: 1, nome: 'Etiqueta Térmica', sku: 'INS-ET-001', custo: 0.08, unidade: 'un', peso: 2 },
    { id: 2, nome: 'Fita Adesiva Transp.', sku: 'INS-FA-001', custo: 0.05, unidade: 'm', peso: 5 },
    { id: 3, nome: 'Fita Gomada', sku: 'INS-FG-001', custo: 0.12, unidade: 'm', peso: 5 },
    { id: 4, nome: 'Papel Seda', sku: 'INS-PS-001', custo: 0.15, unidade: 'folha', peso: 3 },
    { id: 5, nome: 'Tag Agradecimento', sku: 'INS-TAG-001', custo: 0.10, unidade: 'un', peso: 2 },
];

export const CANAIS_INICIAL = {
    meli: {
        id: 'meli',
        nome: 'Mercado Livre',
        txHolding: 2.00,
        txFixaBaixa: 6.75,
        txFixaAlta: 25.00,
        limiarTxFixa: 79.00,
        txVariavel: 0.165,
        ads: 0.03,
        imposto: 0.10,
        ativo: true
    },
    shopee: {
        id: 'shopee',
        nome: 'Shopee',
        txHolding: 2.00,
        txFixa: 4.00,
        txVariavel: 0.22,
        ads: 0.03,
        imposto: 0.10,
        ativo: true
    }
};
